<template>
	<div class="product">
		<div class="top">
			<div class="top-img">
				<img
					v-lazy="productData.banner"
					:key="productData.banner"
					alt="top"
				/>
			</div>
			<div class="top-center">
				<p>{{ productData.name }}</p>
				<span>{{ productData.sketch }}</span>
				<el-button
					class="banner-btn"
					plain
					@click="
						() => {
							this.$router.push('/formSub')
						}
					"
					>立即咨询</el-button
				>
			</div>
		</div>
		<div class="container">
			<div
				v-if="!isMobileEnd"
				class="containerBg"
				v-lazy:background-image="containerBgUrl"
			></div>
			<div
				v-else
				class="containerBg"
				v-lazy:background-image="containerBgUrl"
			></div>
			<div class="content">
				<div class="inner">
					<div class="product-function">
						<div class="title">
							<span class="title-text">产品功能</span>
							<span class="title-desc"
								>功能点完善并深入，满足客户相应需求</span
							>
						</div>
						<div class="product-function-center">
							<product-features
								:overview="productData.overview"
								:productName="productData.name"
								:outlined="productData.outlined"
								:capabilities="productData.capabilities"
							/>
						</div>
					</div>

					<div class="product-scenario">
						<div class="title">
							<span class="title-text">应用场景</span>
						</div>
						<div class="product-scenario-center">
							<app-scenario :scenesList="productData.scenes" />
						</div>
					</div>

					<div class="product-feature">
						<div class="title">
							<span class="title-text">产品特点</span>
							<span class="title-desc"
								>精准提炼本产品，高效了解其优势</span
							>
						</div>
						<div class="product-feature-center">
							<div
								class="product-feature-center-item"
								v-for="(i, index) in productData.features"
								:key="index"
							>
								<img
									v-lazy="i.featureImg"
									:key="i.featureImg"
									alt="方案特点"
								/>
								<h5>{{ i.featureName }}</h5>
								<p>{{ i.featureIntroduction }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="left"></div>
			<div class="right"></div>
		</div>
		<div class="open-api" v-lazy:background-image="openBgUrl">
			<div class="open-api-center">
				<div class="open-api-center-A">快速体验慧脑智能开放平台</div>
				<p class="open-api-center-B">
					让您快速了解并体验更多我们产品相关的能力
				</p>
				<div class="open-api-center-C">
					<el-input
						placeholder="您的手机号码"
						class="open-api-center-C-input"
						v-model="phone"
						maxlength="11"
						@input="handleInput"
					>
						<el-button slot="append" @click="handleOpenAi">
							立即体验</el-button
						>
					</el-input>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppScenario from './childCpn/AppScenario'
import ProductFeatures from './childCpn/ProductFeatures'
import { getProductDetails } from '@/network/product/index.js'
export default {
	name: 'Product',
	data() {
		return {
			containerBgUrl: require('@/assets/img/containerBg.png'),
			openBgUrl: require('@/assets/img/openBg.jpg'),
			productData: {
				name: '', //产品名称
				sketch: '', //产品简述
				banner: '', //banner图
				introduction: '', //产品介绍
				overview: '', //产品概况
				outlined: [
					//特点简述数组
					{
						briefDesc: '',
					},
					{
						briefDesc: '',
					},
					{
						briefDesc: '',
					},
				], //特点简述数组
				capabilities: [
					//功能数组
					{
						capacityImg: '', //功能图片
						capacitySelectedImg: '', //选中功能图片
						capacityName: '', //产品功能
						capacityIntroduction: '', //功能具体描述
					},
					{
						capacityImg: '', //功能图片
						capacitySelectedImg: '', //选中功能图片
						capacityName: '', //产品功能
						capacityIntroduction: '', //功能具体描述
					},
					{
						capacityImg: '', //功能图片
						capacitySelectedImg: '', //选中功能图片
						capacityName: '', //产品功能
						capacityIntroduction: '', //功能具体描述
					},
					{
						capacityImg: '', //功能图片
						capacitySelectedImg: '', //选中功能图片
						capacityName: '', //产品功能
						capacityIntroduction: '', //功能具体描述
					},
					{
						capacityImg: '', //功能图片
						capacitySelectedImg: '', //选中功能图片
						capacityName: '', //产品功能
						capacityIntroduction: '', //功能具体描述
					},
					{
						capacityImg: '', //功能图片
						capacitySelectedImg: '', //选中功能图片
						capacityName: '', //产品功能
						capacityIntroduction: '', //功能具体描述
					},
				],
				scenes: [
					//使用场景数组
					{
						sceneName: '', //使用场景
						sceneImg: '', //场景图片
					},
					{
						sceneName: '', //使用场景
						sceneImg: '', //场景图片
					},
					{
						sceneName: '', //使用场景
						sceneImg: '', //场景图片
					},
					{
						sceneName: '', //使用场景
						sceneImg: '', //场景图片
					},
					{
						sceneName: '', //使用场景
						sceneImg: '', //场景图片
					},
				],
				features: [
					//产品特点数组
					{
						featureName: '', //产品特点
						featureImg: '', //产品特点图片
						featureIntroduction: '', //产品特点具体描述
					},
					{
						featureName: '', //产品特点
						featureImg: '', //产品特点图片
						featureIntroduction: '', //产品特点具体描述
					},
					{
						featureName: '', //产品特点
						featureImg: '', //产品特点图片
						featureIntroduction: '', //产品特点具体描述
					},
					{
						featureName: '', //产品特点
						featureImg: '', //产品特点图片
						featureIntroduction: '', //产品特点具体描述
					},
				],
			},
			phone: '',
		}
	},
	watch: {
		// 解决路由跳转同一个页面，携带不同参数，页面不刷新问题
		$route(to, from) {
			this.$store.state.activeIndex = '3'
			if (to.query.id != from.query.id) {
				this.getProductData(this.$route.query.id)
			}
		},
	},
	created() {
		this.$store.state.activeIndex = '3'
	},
	mounted() {
		if (this.$route.query.id) {
			this.getProductData(this.$route.query.id)
		}
	},
	methods: {
		// 手机号输入框过滤数字
		handleInput(e) {
			this.phone = e.replace(/[^\d]/g, '')
		},
		getProductData(id) {
			getProductDetails(id)
				.then((res) => {
					if (res.data.code == 200) {
						let formData = res.data.data
						//产品功能数组
						const capabilitiesList = formData.capabilities.map(
							(item) => {
								let obj = Object.assign(item, {
									capacityImg:
										window.baseUrl + item.capacityImg,
									capacitySelectedImg:
										window.baseUrl +
										item.capacitySelectedImg,
								})
								return obj
							},
						)
						//应用场景数组
						const scenesList = formData.scenes.map((item) => {
							let isMp4
							let Url = item.sceneImg
							let findStr = Url.lastIndexOf('.')
							let type = Url.slice(findStr)
							if (type == '.mp4') {
								isMp4 = true
							} else {
								isMp4 = false
							}
							let obj = Object.assign(item, {
								sceneImg: window.baseUrl + item.sceneImg,
								isMp4,
							})
							return obj
						})
						//产品特点数组
						const formDataList = formData.features.map((item) => {
							let obj = Object.assign(item, {
								featureImg: window.baseUrl + item.featureImg,
							})
							return obj
						})
						this.productData = {
							name: formData.name,
							sketch: formData.sketch,
							banner: this.showPictures(formData.banner),
							introduction: formData.introduction,
							overview: formData.overview,
							outlined: formData.outlined,
							capabilities: capabilitiesList,
							scenes: scenesList,
							features: formDataList,
						}
					}
				})
				.catch(() => {})
		},
		showPictures(path) {
			const acceptArr = ['.png', '.jpg']
			let findStr = path.lastIndexOf('.')
			let type = path.slice(findStr)
			if (acceptArr.indexOf(type) != -1) {
				const imgPath = window.baseUrl + path
				return imgPath
			} else if (type == 'mp4') {
				const mp4Path = window.baseUrl + path
				return mp4Path
			} else {
				return ''
			}
		},
		handleOpenAi() {
			if (this.phone) {
				let url =
					window.openPlatformUrl +
					'#/login?loginStatus=1&phone=' +
					this.phone
				window.open(url, '_blank')
			} else {
				let url = window.openPlatformUrl
				window.open(url, '_blank')
			}
		},
	},
	components: {
		ProductFeatures,
		AppScenario,
	},
	computed: {
		isMobileEnd() {
			return this.$store.state.isMobileEnd
		},
	},

	destroyed() {},
}
</script>
<style lang="scss" scoped>
.product {
	.top {
		width: 100%;
		overflow: hidden;
		/* 1920→1440：高度固定 676px，宽度变窄时 cover 裁切 */
		height: 676px;
		margin-bottom: 160px;
		position: relative;
		.top-img {
			width: 100%;
			height: 100%;
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center;
			}
		}
		.top-center {
			/* 与圣杯中间区对齐：总宽 - 两侧 gutter = 1280 */
			width: calc(100% - 2 * var(--page-gutter));
			min-width: 174px;
			max-width: 680px;
			height: 292px;
			position: absolute;
			left: var(--page-gutter);
			top: 0;
			bottom: 0;
			margin: auto;
			text-align: left;
			p {
				font-size: 64px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 700;
				line-height: 72px;
				color: #ffffff;
				margin-bottom: 40px;
			}
			span {
				max-height: 72px;
				display: block;
				font-size: 18px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 400;
				color: #ffffff;
				line-height: 26px;
				margin-bottom: 60px;
			}
			.banner-btn {
				width: 180px;
				height: 50px;
				background-color: #2185ff;
				color: #ffffff;
				box-shadow: 4px 4px 9px 0px rgba(54, 121, 202, 0.3);
				border-radius: 50px;
				font-size: 15px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 500;
				line-height: 50px;
				padding: 0;
				letter-spacing: 1px;
				border: 1px solid transparent;
				&:hover {
					background-color: #55a4ff;
				}
			}
		}
	}
	.container {
		position: relative;
	}
	.containerBg {
		width: 100%;
		height: 684px;
		position: absolute;
		// top: 1864px;
		bottom: -164px;
		z-index: -1;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
	}
	// 三栏都需要浮动
	.center,
	.left,
	.right {
		float: left;
	}
	// 左右两栏固定宽度
	.left,
	.right {
		width: var(--page-gutter);
		background-color: #fff;
	}
	// 中间栏  因为需要自适应所以设置宽度100%
	.center {
		width: 100%;
	}
	.left {
		margin-left: -100%;
	}
	.right {
		margin-left: calc(0px - var(--page-gutter));
	}
	.inner {
		margin: 0 var(--page-gutter);
	}
	.open-api {
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		&-center {
			text-align: center;
			padding: 120px 0 100px 0;
			&-A {
				font-size: 52px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 500;
				color: #ffffff;
				line-height: 52px;
			}
			&-B {
				font-size: 18px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 400;
				color: #ffffff;
				line-height: 24px;
				margin: 24px 0 40px 0;
			}
			&-C {
				position: relative;
				&-input {
					width: 688px;
					height: 80px;
					border-radius: 4px;
					font-size: 18px;
					::v-deep .el-input__inner {
						height: 80px;
						line-height: 80px;
					}
					::v-deep .el-input-group__append {
						width: 180px;
						background-color: #2185ff;
						border: 1px solid #2185ff;
						color: #ffffff;
						font-size: 24px;
					}
				}
				.error-message {
					position: absolute;
					top: 86px;
					left: 610px;
					display: block;
					color: red;
				}
				.is-invalid ::v-deep .el-input__inner {
					border-color: red;
				}
			}
		}
	}

	.content {
		.product-function {
			/* 圣杯中间栏内铺满；卡片尺寸固定 px，两侧空白由 --page-gutter 自适应 */
			width: 100%;
			margin-bottom: 85px;
			box-sizing: border-box;
			background-color: #ffffff;
			position: relative;
			z-index: 1;

			.title {
				width: 100%;
				margin: 0 0 60px;
				box-sizing: border-box;
			}

			&-center {
				width: 100%;
				box-sizing: border-box;
			}
		}
		.product-scenario {
			width: 100%;
			margin-bottom: 160px;
			&-center {
				width: 100%;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
		.product-feature {
			width: 100%;
			margin-bottom: 160px;
			&-center {
				width: 100%;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr 1fr;
				grid-auto-flow: row;
				justify-content: space-around;
				&-item {
					height: 200px;
					background-color: #ffffff;
					text-align: center;
					padding: 40px 0;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					img {
						width: 60px;
						height: 60px;
					}
					h5 {
						height: 24px;
						font-size: 24px;
						font-family: 'PingFang SC', 'Source Han Sans SC';
						font-weight: 700;
						color: #485163;
						line-height: 24px;
						margin: 16px 0;
					}
					p {
						width: 240px;
						font-size: 16px;
						font-family: 'PingFang SC', 'Source Han Sans SC';
						font-weight: 400;
						color: #485163;
						line-height: 24px;
					}
				}
			}
		}
	}
}
.title {
	width: 100%;
	margin-bottom: 60px;
	text-align: center;
	.title-text {
		height: 60px;
		font-size: 52px;
		font-family: 'PingFang SC', 'Source Han Sans SC';
		font-weight: 500;
		color: #333333;
		line-height: 60px;
		display: block;
	}
	.title-desc {
		display: inline-block;
		font-size: 24px;
		font-family: 'PingFang SC', 'Source Han Sans SC';
		font-weight: 400;
		color: #666666;
		line-height: 32px;
		margin-top: 12px;
	}
}
@media screen and (max-width: 768px) {
	.product {
		.top {
			height: 178px;
			margin-bottom: 24px;
			.top-center {
				height: 52px;
				width: calc(100% - 80px);
				max-width: none;
				left: 40px;
				p {
					font-size: 16px;
					line-height: 22px;
					margin-bottom: 8px;
				}
				span {
					display: none;
				}
				.banner-btn {
					width: 56px;
					height: 22px;
					font-size: 10px;
					line-height: 10px;
					border-radius: 22px;
					letter-spacing: 0;
					&::after {
						transform: scale(0.5);
					}
				}
			}
		}
		.containerBg {
			bottom: -24px;
			height: 340px;
		}
		// 左右两栏固定宽度
		.left,
		.right {
			width: 16px;
		}
		.right {
			margin-left: -16px;
		}
		.inner {
			margin: 0 16px;
		}
		.open-api {
			display: none;
		}
		.content {
			.product-function {
				width: 100%;
				max-width: 100%;
				margin-left: 0;
				margin-right: 0;
				margin-bottom: 24px;
				background-color: #ffffff !important;
				position: relative;
				z-index: 1;

				.title {
					margin-bottom: 16px;
					padding: 0;
				}

				&-center {
					padding: 0;
				}
			}
			.product-scenario {
				margin-bottom: 24px;
				.title {
					margin-bottom: 16px;
				}
			}
			.product-feature {
				margin-bottom: 24px;
				.title {
					margin-bottom: 16px;
				}
				&-center {
					grid-template-columns: 1fr 1fr;
					gap: 10px;
					&-item {
						height: 80px;
						padding: 16px 10px;
						border: 1px solid #e6e7ee;
						border-radius: 4px;
						img {
							width: 36px;
							height: 36px;
						}
						h5 {
							height: 20px;
							font-size: 14px;
							font-weight: 500;
							line-height: 20px;
							margin: 8px 0;
						}
						p {
							display: none;
						}
					}
				}
			}
		}

		.title {
			.title-text {
				height: 24px;
				font-size: 16px;
				font-weight: 400;
				color: #020814;
				line-height: 24px;
			}
			.title-desc {
				font-size: 10px;
				color: #030c22;
				line-height: 18px;
			}
		}
	}
}
</style>
